module.exports = __webpack_public_path__ + "static/img/ent-4.5b03068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-4.jpg
// module id = IEkT
// module chunks = 51